import { render, staticRenderFns } from "./LocalInformation.vue?vue&type=template&id=ec7dbb92&scoped=true&"
import script from "./LocalInformation.vue?vue&type=script&lang=js&"
export * from "./LocalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7dbb92",
  null
  
)

export default component.exports